import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import { MessageGroupLeft, MessageLeft, MessageRight } from "../../components/Message";
import { useWebSocketContext } from "../../../../contexts/WebSocketContext";
function MessageListItem(_ref) {
  var message = _ref.message;
  var _useWebSocketContext = useWebSocketContext(),
    wsClient = _useWebSocketContext.wsClient;
  var authUserId = useSelector(function (state) {
    return state.authentication.userId;
  });
  useEffect(function () {
    var messageState = message.states.find(function (state) {
      return state.user.id === authUserId;
    });
    if (messageState.viewedAt) return;
    var newMessageState = JSON.parse(JSON.stringify(messageState));
    newMessageState.userId = authUserId;
    newMessageState.viewedAt = moment().toISOString();
    wsClient && wsClient.send("/secured/messageState", {}, JSON.stringify(newMessageState));
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "scroll-list-item"
  }, message.user.id === authUserId ? /*#__PURE__*/React.createElement(MessageRight, message) : message.group.multi ? /*#__PURE__*/React.createElement(MessageGroupLeft, message) : /*#__PURE__*/React.createElement(MessageLeft, message));
}
export default MessageListItem;